import { defineMessages } from 'react-intl';

const messages = defineMessages({
    lastName: {
        id: 'InputLastName.lastName',
        defaultMessage: 'Enter last name',
    },
    lastNameRequired: {
        id: 'InputLastName.lastNameRequired',
        defaultMessage: 'Last name required',
    },
    lastNameInvalid: {
        id: 'InputLastName.lastNameInvalid',
        defaultMessage: 'Last name must have 1 to 75 characters',
    },
});

export default messages;
